import { Container, Row, Col } from 'react-bootstrap';
import { Envelope, Instagram, Linkedin } from 'react-bootstrap-icons';

const contacts = [
  {
    icon: <Envelope size={26} />,
    label: 'Email',
    value: 'bjeong@uwaterloo.ca',
    href: 'mailto:bjeong@uwaterloo.ca',
  },
  {
    icon: <Linkedin size={26} />,
    label: 'LinkedIn',
    value: 'linkedin.com/in/becky-jeong',
    href: 'https://linkedin.com/in/becky-jeong',
  },
  {
    icon: <Instagram size={26} />,
    label: 'Instagram',
    value: '@becky_jeong_',
    href: 'https://instagram.com/becky_jeong_',
  },
];

export const ContactInfo = () => {
  return (
    <section className="contactinfo" id="contact-info">
      <Container>
        <h2>Contact Information</h2>
        <Row className="justify-content-center">
          {contacts.map((contact, index) => (
            <Col key={index} xs={12} sm={4} className="contactinfo-item">
              <a
                href={contact.href}
                target={contact.href.startsWith('http') ? '_blank' : undefined}
                rel="noreferrer"
              >
                <span className="contactinfo-icon">{contact.icon}</span>
                <span className="contactinfo-label">{contact.label}</span>
                <span className="contactinfo-value">{contact.value}</span>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};
